import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { ConfirmDialogData } from './confirm-dialog.model';
import { MibButtonComponent } from '../../button';
import { MibIconsModule } from '../../icons';

@Component({
  imports: [MibButtonComponent, MibIconsModule],
  templateUrl: './confirm-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MibConfirmDialog {
  readonly dialogRef = inject<DialogRef<boolean>>(DialogRef);
  readonly data = inject<ConfirmDialogData>(DIALOG_DATA);
}
